"use strict";

exports.__esModule = true;
exports.mapParamToItem = exports.getStaticBranchValue = exports.getRefBranchValue = void 0;
const mapParamToItem = ({
  metadata,
  params,
  isMobile,
  validate,
  createItem
}) => {
  if (!metadata || !validate(metadata.type)) {
    return undefined;
  }
  const branch = getMetadataValue(metadata, isMobile);
  if (!branch) {
    return undefined;
  }
  switch (branch.type) {
    case 'static':
      return createItem(metadata.type, getStaticBranchValue(branch));
    case 'ref':
      return createItem(metadata.type, getRefBranchValue({
        branch,
        params,
        metadataGetter: m => getMetadataValue(m, isMobile)
      }));
    default:
      const _exhaustiveCheck = branch;
      throw new Error(`Unexpected type on: ${_exhaustiveCheck}`);
  }
};
exports.mapParamToItem = mapParamToItem;
const getMetadataValue = (metadata, isMobile) => isMobile ? metadata.mobileDefaultValue ?? metadata.defaultValue : metadata.defaultValue;
const getStaticBranchValue = branch => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const {
    type: _type,
    ...rest
  } = branch;
  const isPrimitiveValue = Object.keys(rest).length === 1 && 'value' in rest;
  return isPrimitiveValue ? rest.value : rest;
};

/*
  getRefBranchValue will go through the ref chain to extract the value, if its not possible or value is undefined,
  fallback will be used to resolve the value
*/
exports.getStaticBranchValue = getStaticBranchValue;
const getRefBranchValue = ({
  branch,
  params,
  metadataGetter
}) => {
  const primaryBranch = resolveRefChain(branch, params, metadataGetter);
  if (primaryBranch) {
    return primaryBranch;
  }
  if (branch.fallback) {
    switch (branch.fallback.type) {
      case 'static':
        return getStaticBranchValue(branch.fallback);
      case 'ref':
        return resolveRefChain(branch.fallback, params, metadataGetter);
      default:
        const _exhaustiveCheck = branch.fallback;
        throw new Error(`Unexpected type on: ${_exhaustiveCheck}`);
    }
  }
  return undefined;
};
exports.getRefBranchValue = getRefBranchValue;
const MAX_DEPTH = 5;
const resolveRefChain = (branch, params, metadataGetter, visited = new Set(), depth = 0) => {
  var _params$branch$ref;
  if (depth >= MAX_DEPTH) {
    console.error(`Max depth reached at ${branch.ref}`);
    return undefined;
  }
  if (visited.has(branch.ref)) {
    console.error(`Circular reference at ${branch.ref}`);
    return undefined;
  }
  visited.add(branch.ref);
  const metadata = (_params$branch$ref = params[branch.ref]) == null ? void 0 : _params$branch$ref.metadata;
  const next = metadata && metadataGetter(metadata);
  if (!next) {
    return undefined;
  }
  switch (next.type) {
    case 'static':
      return getStaticBranchValue(next);
    case 'ref':
      return resolveRefChain(next, params, metadataGetter, visited, depth + 1);
    default:
      const _exhaustiveCheck = next;
      throw new Error(`Unexpected type on: ${_exhaustiveCheck}`);
  }
};
//# sourceMappingURL=conversion-utils.js.map